<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import CountryAutocomplete from '~/components/search/forms/CountryAutocomplete.vue'

    @Component({mixins: [CountryAutocomplete]})
    export class CityCountryAutocomplete extends Vue {
        load() {
            if (!this.search && !this.city && this.entries.length === 0) {
                this.entries = this.defaultCities
            } else if (this.city) {
                this.entries = [this.city]
            }
        }

        async initSearch(val) {
            if ((this.entries.length > 0 && this.entries.indexOf(val) !== -1) || !val) return
            this.loading = true
            if (this.cancelTokenSource) this.cancelTokenSource.cancel('Operation canceled by the user.')
            this.cancelTokenSource = this.$axios.CancelToken.source()

            try {
                let cities = [],
                    countries = []
                await Promise.all([
                    (async () => {
                        cities = await this.searchCities(val, false)
                    })(),
                    (async () => {
                        countries = await this.searchCountries(val, false)
                    })(),
                ])
                this.entries = [...cities, ...countries]

                if (!this.entries.length) {
                    this.tryResearch.status = true
                    this.tryResearch.message =
                        this.isMobile && this.showDialog
                            ? this.$t('try_rewrite_destination_mobile')
                            : this.$t('try_rewrite_destination')
                }
            } finally {
                this.loading = false
            }
        }

        icon(type) {
            switch (type) {
                case 'country':
                    return this.locationIcon
                default:
                    return this.cityIcon
            }
        }

        get cityIcon() {
            return 'mdi-city'
        }

        itemLabel(entry) {
            if (entry.type === 'city') {
                return (
                    `${entry.name}, ${entry.parentName}` +
                    (entry.parentName !== entry.countryName ? `, ${entry.countryName}` : '')
                )
            }
            return entry.name
        }
    }

    export default {...toNative(CityCountryAutocomplete), ssrRender: CountryAutocomplete.ssrRender}
</script>
